<div class="zx-max-100-vh h-100 w-100 d-flex flex-column flex-grow-1">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeApplyToAllDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- [plotter] -->
    <!-- NOT Possible -->
    <div *ngIf="!isOriginalPossible && printingService === 'plotter'"
        class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100">
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-rtl]="!isRTL" [class.text-white]="isDarkMode">
            {{ "apply-to-all-no-title" | translate }}
        </h4>
        <p class="m-0 px-2 zx-text-medium w-100 text-center py-3" [class.text-white]="isDarkMode"
            [class.zx-ltr]="!isRTL" [class.zx-rtl]="isRTL">
            <span *ngIf="currentFile.images?.length === 1">
                {{ "apply-to-all-no-explanation-1-singlepage" | translate }}
            </span>
            <span *ngIf="currentFile.images?.length !== 1" [class.zx-ltr]="!isRTL" [class.zx-rtl]="isRTL">
                <span>
                    {{ "apply-to-all-no-explanation-1-manypages-1" | translate }}
                </span>
                <b>
                    {{currentImageIndex + 1}}
                </b>
                <span>
                    {{ "apply-to-all-no-explanation-1-manypages-2" | translate }}
                </span>
            </span>
            <b [class.zx-ltr]="!isRTL" [class.zx-rtl]="isRTL">
                <span>
                    {{ currentFile.fileName.split('-')[1] | slice:0:16 }}
                </span>
                <span class="zx-text-tiny" *ngIf="currentFile.fileName.split('-')[1].length > 16">
                    ...
                </span>
            </b>
            <span>
                {{ "apply-to-all-no-explanation-2" | translate }}
            </span>
            <span> - </span>
            <b>
                {{ paperWidth }}
            </b>
            <b>
                {{ "printing-table.dimensions-cm" | translate }}
            </b>
            <span>.</span>
        </p>
        <p class="m-0 px-2 zx-text-medium w-100 text-center text-green fw-bold" [class.zx-ltr]="!isRTL"
            [class.zx-rtl]="isRTL">
            {{ "apply-to-all-no-explanation-3" | translate }}
        </p>
        <div class="d-flex flex-grow-1 justify-content-center align-items-end w-100 pt-3">
            <button color="primary" mat-raised-button class="text-white rounded-pill zx-btn-single w-100"
                (click)="closeApplyToAllDialog()">
                {{ "error-content-ok-btn" | translate }}
            </button>
        </div>
    </div>

    <!-- [plotter] -->
    <!-- Possible -->
    <div *ngIf="isOriginalPossible && printingService === 'plotter'"
        class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100">
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-rtl]="!isRTL" [class.text-white]="isDarkMode">
            {{ "apply-to-all-yes-title" | translate }}
        </h4>
        <p class="m-0 px-2 zx-text-medium w-100 text-center py-3" [class.text-white]="isDarkMode"
            [class.zx-ltr]="!isRTL" [class.zx-rtl]="isRTL">
            <span *ngIf="currentFile.images?.length === 1">
                {{ "apply-to-all-yes-explanation-1-singlepage" | translate }}
            </span>
            <span *ngIf="currentFile.images?.length !== 1" [class.zx-ltr]="!isRTL" [class.zx-rtl]="isRTL">
                <span>
                    {{ "apply-to-all-yes-explanation-1-manypages-1" | translate }}
                </span>
                <b>
                    {{currentImageIndex + 1}}
                </b>
                <span>
                    {{ "apply-to-all-yes-explanation-1-manypages-2" | translate }}
                </span>
            </span>
            <b [class.zx-ltr]="!isRTL" [class.zx-rtl]="isRTL">
                <span>
                    {{ currentFile.fileName.split('-')[1] | slice:0:16 }}
                </span>
                <span class="zx-text-tiny" *ngIf="currentFile.fileName.split('-')[1].length > 16">
                    ...
                </span>
            </b>
            <span>
                {{ "apply-to-all-yes-explanation-2" | translate }}
            </span>
        </p>
        <div class="m-0 px-2 w-100 d-flex flex-column justify-content-center align-items-center gap-2 flex-grow-1"
            [class.zx-ltr]="!isRTL" [class.zx-rtl]="isRTL">
            <!-- paper -->
            <div class="w-100 d-flex justify-content-between zx-w-lg-50 align-items-center">
                <span class="text-green">
                    {{ "apply-to-all-paper-type" | translate }}
                </span>
                <b class="text-green rounded-pill px-2 px-sm-3 py-1 zx-border-gray-25-pr">
                    {{ "paper-type.name." + paperType | translate }}
                </b>
            </div>
            <!-- color -->
            <div class="w-100 d-flex justify-content-between zx-w-lg-50 align-items-center">
                <span class="text-green">
                    {{ "printing-table.color" | translate }}
                </span>
                <b class="text-green rounded-pill px-2 px-sm-3 py-1 zx-border-gray-25-pr" *ngIf="!printSettings.bw">
                    {{ "printing-table.color-color" | translate }}
                </b>
                <b class="text-green rounded-pill px-2 px-sm-3 py-1 zx-border-gray-25-pr" *ngIf="printSettings.bw">
                    {{ "printing-table.color-bandw" | translate }}
                </b>
            </div>
            <!-- borders -->
            <div class="w-100 d-flex justify-content-between zx-w-lg-50 align-items-center">
                <span class="text-green">
                    {{ "printing-table.borders" | translate }}
                </span>
                <b class="text-green rounded-pill px-2 px-sm-3 py-1 zx-border-gray-25-pr"
                    *ngIf="!printSettings.cmFromTop">
                    {{ "su-management.branches_no" | translate }}
                </b>
                <b class="text-green rounded-pill px-2 px-sm-3 py-1 zx-border-gray-25-pr"
                    *ngIf="printSettings.cmFromTop">
                    {{ "su-management.branches_yes" | translate }}
                </b>
            </div>
            <!-- center -->
            <div class="w-100 d-flex justify-content-between zx-w-lg-50 align-items-center">
                <span class="text-green">
                    {{ "printing-table.center" | translate }}
                </span>
                <b class="text-green rounded-pill px-2 px-sm-3 py-1 zx-border-gray-25-pr"
                    *ngIf="!printSettings.centered">
                    {{ "su-management.branches_no" | translate }}
                </b>
                <b class="text-green rounded-pill px-2 px-sm-3 py-1 zx-border-gray-25-pr"
                    *ngIf="printSettings.centered">
                    {{ "su-management.branches_yes" | translate }}
                </b>
            </div>
            <!-- copies -->
            <div class="w-100 d-flex justify-content-between zx-w-lg-50 align-items-center">
                <span class="text-green">
                    {{ "printing-table.copies" | translate }}
                </span>
                <b class="text-green rounded-pill px-2 px-sm-3 py-1 zx-border-gray-25-pr">
                    {{ printSettings.numOfCopies }}
                </b>
            </div>
        </div>

        <div class="d-flex justify-content-center align-items-end w-100 pt-3">
            <button color="primary" mat-raised-button class="text-white rounded-pill zx-btn-single w-100"
                (click)="closeApplyToAllDialog()">
                {{ "error-content-ok-btn" | translate }}
            </button>
        </div>
    </div>

    <!-- [express] -->
    <div *ngIf="printingService === 'express'"
        class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 w-100"
        [class.gap-3]="isOriginalPossible  && !printSettings.fit" [class.gap-2]="!isOriginalPossible">
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-rtl]="!isRTL" [class.text-white]="isDarkMode">
            {{ "apply-to-all-yes-title" | translate }}
        </h4>
        <div class="w-100 d-flex flex-column justify-content-center align-items-center">
            <p class="m-0 px-2 zx-text-medium w-100 text-center py-3" [class.text-white]="isDarkMode"
                [class.zx-ltr]="!isRTL" [class.zx-rtl]="isRTL">
                <span>
                    {{ "apply-to-all-yes-explanation-1-singlepage" | translate }}
                </span>
                <b [class.zx-ltr]="!isRTL" [class.zx-rtl]="isRTL">
                    <span>
                        {{ currentFile.fileName.split('-')[1] | slice:0:16 }}
                    </span>
                    <span class="zx-text-tiny" *ngIf="currentFile.fileName.split('-')[1].length > 16">
                        ...
                    </span>
                </b>
                <span>
                    {{ "apply-to-all-yes-explanation-2" | translate }}
                </span>

            </p>
            <p *ngIf="!isOriginalPossible" class="text-red zx-text-medium text-center zx-max-w-880"
                [class.zx-rext-white]="isDarkMode" [class.zx-rtl]="isRTL">
                {{ "apply-to-all-cant-apply-original-size" | translate }}
            </p>
        </div>

        <div class="m-0 px-2 w-100 d-flex flex-column justify-content-center align-items-center gap-2 flex-grow-1"
            [class.gap-1]="isOriginalPossible && !printSettings.fit" [class.zx-ltr]="!isRTL" [class.zx-rtl]="isRTL">
            <!-- paper -->
            <div class="w-100 d-flex justify-content-between zx-w-lg-50 align-items-center">
                <span class="text-green">
                    {{ "apply-to-all-paper-type" | translate }}
                </span>
                <b class="text-green rounded-pill px-2 px-sm-3 py-1 zx-border-gray-25-pr">
                    {{ "paper-type.name." + paperType | translate }}
                </b>
            </div>
            <!-- size -->
            <div class="w-100 d-flex justify-content-between zx-w-lg-50 align-items-center">
                <span class="text-green">
                    {{ "printing-table.size" | translate }}
                </span>
                <b class="text-green rounded-pill px-2 px-sm-3 py-1 zx-border-gray-25-pr"
                    *ngIf="!printSettings.fit && isOriginalPossible">
                    {{ "printing-table.size-original" | translate }}
                </b>
                <b class="text-green rounded-pill px-2 px-sm-3 py-1 zx-border-gray-25-pr"
                    *ngIf="!(!printSettings.fit && isOriginalPossible)">
                    <span *ngIf="!printSettings.cropRatio">
                        {{ "printing-table.size-maximal" | translate }}
                    </span>
                    <span *ngIf="printSettings.cropRatio">
                        {{ "printing-table.full-cover" | translate }}
                    </span>
                </b>
            </div>
            <!-- color -->
            <div class="w-100 d-flex justify-content-between zx-w-lg-50 align-items-center">
                <span class="text-green">
                    {{ "printing-table.color" | translate }}
                </span>
                <b class="text-green rounded-pill px-2 px-sm-3 py-1 zx-border-gray-25-pr" *ngIf="!printSettings.bw">
                    {{ "printing-table.color-color" | translate }}
                </b>
                <b class="text-green rounded-pill px-2 px-sm-3 py-1 zx-border-gray-25-pr" *ngIf="printSettings.bw">
                    {{ "printing-table.color-bandw" | translate }}
                </b>
            </div>
            <!-- sides -->
            <div class="w-100 d-flex justify-content-between zx-w-lg-50 align-items-center">
                <span class="text-green">
                    {{ "printing-table.sides" | translate }}
                </span>
                <b class="text-green rounded-pill px-2 px-sm-3 py-1 zx-border-gray-25-pr"
                    *ngIf="!printSettings.doubleSided">
                    {{ "printing-table.sides-one" | translate }}
                </b>
                <b class="text-green rounded-pill px-2 px-sm-3 py-1 zx-border-gray-25-pr"
                    *ngIf="printSettings.doubleSided">
                    {{ "printing-table.sides-two" | translate }}
                </b>
            </div>
            <!-- copies -->
            <div class="w-100 d-flex justify-content-between zx-w-lg-50 align-items-center">
                <span class="text-green">
                    {{ "printing-table.copies" | translate }}
                </span>
                <b class="text-green rounded-pill px-2 px-sm-3 py-1 zx-border-gray-25-pr">
                    {{ printSettings.numOfCopies }}
                </b>
            </div>
        </div>

        <div class="d-flex justify-content-center align-items-end w-100 pt-3">
            <button color="primary" mat-raised-button class="text-white rounded-pill zx-btn-single w-100"
                (click)="closeApplyToAllDialog()">
                {{ "error-content-ok-btn" | translate }}
            </button>
        </div>
    </div>

</div>